import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
function SubChangePassword({ id }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [serror, setSerror] = useState("");
  const formdata = {
    newpassword: "",
    confirmpassword: "",
  };
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 3000); // 3000 milliseconds = 3 seconds
    }
    if (serror) {
      timer = setTimeout(() => {
        setSerror("");
      }, 3000); // 3000 milliseconds = 3 seconds
    }

    return () => {
      clearTimeout(timer);
    };
  }, [error, serror]);
  const formik = useFormik({
    initialValues: formdata,
    validationSchema: Yup.object({
      newpassword: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .max(12, "Password must be at most 12 characters")
        .required("new Password is required"),
      confirmpassword: Yup.string()
        .oneOf([Yup.ref("newpassword"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      const userdata = {
        password: values.newpassword,
      };
      await axios
        .post(
          `${process.env.REACT_APP_BASE_URL}admin-sub-changepassword/${id}`,
          userdata,
          {
            headers: {
              "x-access-token": localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            setSuccess(response.data.message);
            window.location.href = "/settings";
          }
        })
        .catch((error) => {
          setSerror(error.response.data);
        });
    },
  });
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <section
      className="login-section d-flex  
        align-items-center  
        justify-content-center  
        "
    >
      <div className="w-100">
        <form onSubmit={formik.handleSubmit}>
          <div className="login-feild-wrap">
            <div className="myinput">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter New Password"
                name="newpassword"
                value={formik.values.newpassword}
                onChange={formik.handleChange}
                className={formik.errors.newpassword ? "errorinput" : ""}
              />
              <span className="eye" onClick={togglePasswordVisibility}>
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>
          </div>
          <div className="error">
            {formik.touched.newpassword && formik.errors.newpassword ? (
              <p>{formik.errors.newpassword}</p>
            ) : null}
          </div>
          <div className="login-feild-wrap">
            <div className="myinput">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Enter Confirm Password"
                name="confirmpassword"
                value={formik.values.confirmpassword}
                onChange={formik.handleChange}
                className={formik.errors.confirmpassword ? "errorinput" : ""}
              />
              <span className="eye" onClick={toggleConfirmPasswordVisibility}>
                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>
          </div>
          <div className="error">
            {formik.touched.confirmpassword && formik.errors.confirmpassword ? (
              <p>{formik.errors.confirmpassword}</p>
            ) : null}
          </div>
          <div className="d-flex justify-content-end">
            <button type="submit" className="mybtn">
              Change Password
            </button>
          </div>
          {error ? (
            <div className="text-success mt-5" role="alert">
              {error}
            </div>
          ) : null}
          {serror ? (
            <div className="text-danger mt-5" role="alert">
              {serror}
            </div>
          ) : null}
          {success && success ? (
            <div className="alert alert-success fixed-top rr">{success} </div>
          ) : null}
        </form>
      </div>
    </section>
  );
}

export default SubChangePassword;
